import { useEffect, useState } from 'react';
import { leaveAPI } from '../../services/api';

// Fired after a leave decision, so the menu's counter updates at once.
export const LEAVE_CHANGED = 'hardwall:leave-changed';
export const announceLeaveChanged = () => window.dispatchEvent(new Event(LEAVE_CHANGED));

const REFRESH_MS = 60 * 1000;

/**
 * How many leave requests wait for a decision (the menu's counter): asked
 * on mount, every minute and after a decision. 0 when not `enabled` (no
 * attendance view permission) or when the count cannot be read.
 */
export const usePendingLeaveCount = (enabled) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return undefined;
    }
    let current = true;
    const load = () => leaveAPI.getPendingCount()
      .then((res) => { if (current) setCount(Number(res.data.count) || 0); })
      .catch(() => { /* the counter is a hint: a failed read leaves it as it was */ });
    load();
    const timer = setInterval(load, REFRESH_MS);
    window.addEventListener(LEAVE_CHANGED, load);
    return () => {
      current = false;
      clearInterval(timer);
      window.removeEventListener(LEAVE_CHANGED, load);
    };
  }, [enabled]);
  return count;
};
